import { findColors, getColorTheme, removeCategoryColumn } from 'util/colors';
import * as googleSheets from './googleSheets';
import invalidate from './invalidate';
import sortDataByDate from './sortDataByDate';
import updateDirty from './updateDirty';

function mergeOriginalColors(chartData, origData) {
  if (origData && origData.series) {
    for (let s = 0; s < origData.series.length; s++) {
      let oData = origData.series[s].data;
      let cData = chartData.series[s] ? chartData.series[s].data : null;
      if (cData) {
        var seriesColor = origData.series[s].color;
        chartData = chartData.setIn(['series', s, 'color'], seriesColor);
        for (let d = 0; d < cData.length; d++) {
          let oItem = oData[d] || null;
          let cItem = cData[d];
          cItem = cItem.setIn(['color'], oItem ? oItem.color : seriesColor);
          chartData = chartData.setIn(['series', s, 'data', d], cItem);
        }
      } else {
        break;
      }
    }
  }
  return chartData;
}

function validChartType(type, charts) {
  if (charts.length) {
    for (let chart of charts) {
      if (chart.type === type) {
        return type;
      }
    }
    return charts[0].type;
  }
  return null;
}

function updateParsedData(chartDoc, action) {
  let { rawDataIo } = chartDoc;
  let chartData = chartDoc.chart.data;
  const origChart = chartDoc.merge({});
  // update raw data box when sheet url is deleted
  if (action.raw || action.error === googleSheets.URL_DELETE_ACTION) {
    chartData = chartData.set('raw', action.raw);
  }

  if (action.error) {
    if (action.error !== googleSheets.URL_DELETE_ACTION) {
      rawDataIo = rawDataIo.set('error', action.error);
    }
    chartData = chartData.merge({
      parsed: null,
      series: null,
      possibleCharts: [],
    });
  } else {
    rawDataIo = rawDataIo.set('error', null);
    const { charts, data, econdataTheme, chartType, tickers } = action;
    if (charts) {
      const type = validChartType(chartDoc.chart.type, charts);
      chartDoc = chartDoc.setIn(['chart', 'type'], type);
      chartData = chartData.set('possibleCharts', charts);
    }
    if (data) {
      const origSeries = origChart.chart.data.series || [];
      const { chart } = chartDoc;
      const { product } = chart;
      const { isScatterplot } = chart.data;
      const [series, offset] = removeCategoryColumn(data);
      chartData = chartData.set('type', data.type);
      chartData = chartData.merge(data);
      if (data.type === 'market' && chartType === 'bar' && origChart.chart.type === 'bar') {
        const origCategories = origChart.chart.data.categories;
        const updatedCategories = data.categories.map((category) => {
          const i = tickers.findIndex(({ company }) => company === category);
          return i > -1 ? origCategories[i] : category;
        });
        if (origCategories && origCategories.length) {
          chartData = chartData.setIn(['categories'], updatedCategories);
        }
        series[0].data.forEach((point, i) => {
          const origPoint = origSeries[0].data[i];
          const origColor = origPoint ? origPoint.color : null;
          if (origColor) {
            chartData = chartData.setIn(['series', 0, 'data', i, 'color'], origColor);
          }
        });
      }
      const themeName = chart.color.theme;
      const getColorProps = findColors(
        series,
        offset,
        product,
        themeName,
        econdataTheme,
        origSeries
      );
      series.forEach((currentSeries, i) => {
        if (isScatterplot) {
          const color = getColorTheme(null, chart.product)[0];
          chartData = chartData.setIn(['series', i, 'color'], color);
        } else {
          const colorProps = getColorProps(currentSeries, i);
          const { seriesIdx } = colorProps;
          if (data.type === 'market' && chartType !== 'bar') {
            const origTicker = origSeries.find(
              (currentOrigSeries) => currentOrigSeries.symbol === currentSeries.symbol
            );
            if (origTicker) {
              chartData = chartData.setIn(['series', seriesIdx, 'name'], origTicker.name);
              chartData = chartData.setIn(['series', seriesIdx, 'markdown'], origTicker.markdown);
              chartData = chartData.setIn(
                ['series', seriesIdx, 'showInLegend'],
                origTicker.showInLegend
              );
            }
          }
          ['color', 'negativeColor'].forEach(
            (prop) => (chartData = chartData.setIn(['series', seriesIdx, prop], colorProps[prop]))
          );
          if (
            data.type === 'market' &&
            chartType === 'column' &&
            origChart.chart.type === 'column'
          ) {
            currentSeries.data.forEach((point, pointIdx) => {
              const origPoint = origSeries[i].data[pointIdx];
              const origColor = origPoint ? origPoint.color : null;
              if (origColor) {
                chartData = chartData.setIn(['series', i, 'data', pointIdx, 'color'], origColor);
              }
            });
          }
        }
      });
      if (data.type !== 'market' && data.type !== 'econ' && !isScatterplot) {
        chartData = mergeOriginalColors(chartData, origChart.chart.data);
      }
    }
  }
  chartDoc = chartDoc.set('rawDataIo', rawDataIo);
  chartDoc = chartDoc.setIn(['chart', 'data'], chartData);
  chartDoc = sortDataByDate(chartDoc);
  chartDoc = invalidate(chartDoc, '*', 'chart/data');
  return updateDirty(chartDoc);
}

export default updateParsedData;
